/*!
 * Oxify Forge Configurator — Oxify
 * Namespace: oxf_* (separate from HE5000's he_* and OXYREVO's ox_*)
 * Block-based: reads options + variant IDs from DOM data attributes emitted by section blocks.
 */
(function(){
  'use strict';

  var CONFIG = (function(){
    try {
      var el = document.querySelector('script[data-oxf-config]');
      if (el && el.textContent) return JSON.parse(el.textContent);
    } catch(e){}
    return {};
  })();

  var ROOT = null;
  // state.seatColor holds { label, variants: { regular, manual, electric, first } }
  // state.addons is { addonKey: { label, price, variantId } }
  var state = {
    exterior: null,    // { label, price, variantId } — exterior color from hero dropdown
    floor: null,       // { label, price, variantId }
    interior: null,    // { label, price, variantId }
    seatType: null,    // { key, label, price }
    seatColor: null,   // { label, variants }
    bibs: null,        // null or { label, price, variantId }
    wg: null,          // { tierKey, label, price, variantId }
    addons: {},        // { key: { label, price, variantId } }
    included: {},      // { key: { label, variantId, chipSelected? } }
    reading: null      // { chipLabel, variantId } — for the Reading Light chip toggle
  };

  // ---------- Utilities ----------
  function money(n){ return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 }); }
  function plus(n){ return '+$' + Number(n).toLocaleString('en-US'); }
  function num(v){ var n = parseFloat(v); return isNaN(n) ? 0 : n; }
  function $(sel){ return ROOT.querySelector(sel); }
  function $$(sel){ return ROOT.querySelectorAll(sel); }
  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  // ---------- Selection handlers ----------
  function bindSwatches(){
    $$('[data-oxf-swatch]').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        var input = el.querySelector('input[type="radio"]');
        if (!input) return;
        var group = input.name;
        $$('input[name="' + group + '"]').forEach(function(inp){
          var lbl = inp.closest('[data-oxf-swatch]');
          if (lbl) lbl.classList.remove('is-on');
          inp.checked = false;
        });
        el.classList.add('is-on');
        input.checked = true;
        captureSwatch(el);
        renderSummary();
      });
    });
  }

  function captureSwatch(el){
    var cat = el.getAttribute('data-cat');
    var label = el.getAttribute('data-label');
    var price = num(el.getAttribute('data-price'));
    if (cat === 'Flooring') {
      state.floor = { label: label, price: price, variantId: el.getAttribute('data-variant') };
    } else if (cat === 'Interior Color') {
      state.interior = { label: label, price: price, variantId: el.getAttribute('data-variant') };
    } else if (cat === 'Seat Color') {
      var seatIsCustom = el.getAttribute('data-oxf-seat-custom') === '1';
      var seatPriorNote = (state.seatColor && state.seatColor.isCustom) ? (state.seatColor.note || '') : '';
      state.seatColor = {
        label: label,
        isCustom: seatIsCustom,
        note: seatIsCustom ? seatPriorNote : '',
        variants: {
          regular: el.getAttribute('data-seat-variant-regular') || null,
          manual: el.getAttribute('data-seat-variant-manual') || null,
          electric: el.getAttribute('data-seat-variant-electric') || null,
          first: el.getAttribute('data-seat-variant-first') || null,
          first_massage: el.getAttribute('data-seat-variant-first-massage') || null
        }
      };
      var seatNoteBox = document.getElementById('oxf-seat-custom-note');
      if (seatNoteBox) seatNoteBox.hidden = !seatIsCustom;
      var seatNoteInput = document.getElementById('oxf-seat-custom-input');
      if (seatNoteInput) {
        seatNoteInput.value = seatIsCustom ? seatPriorNote : '';
        if (seatIsCustom) { setTimeout(function(){ try { seatNoteInput.focus(); } catch(e){} }, 0); }
      }
    }
    updateStepPreview(cat, el);
  }

  // Update the step's hero preview image.
  // Priority:
  //   1. Selected block's own fallback image (per-option hero, highest)
  //   2. Section-level hero fallback (locked/static across options)
  //   3. Selected swatch's small image (upscaled)
  //   4. Empty placeholder
  // Caption always reflects the currently selected option's label.
  function updateStepPreview(cat, el){
    var preview = ROOT.querySelector('.oxf-step-preview[data-oxf-preview="' + cat + '"]');
    if (!preview) return;
    var imgEl = preview.querySelector('[data-oxf-preview-img]');
    var emptyEl = preview.querySelector('.oxf-preview-empty');
    var captionEl = preview.querySelector('[data-oxf-preview-caption]');
    var blockFallback = el ? el.getAttribute('data-fallback-image') : '';
    var sectionFallback = preview.getAttribute('data-hero-fallback') || '';
    var swatchSrc = el ? el.getAttribute('data-preview-image') : '';
    var label = el ? el.getAttribute('data-label') : '';
    var src = blockFallback || sectionFallback || swatchSrc;
    if (src) {
      if (imgEl) { imgEl.src = src; imgEl.alt = label || ''; imgEl.hidden = false; }
      if (captionEl) {
        if (label) { captionEl.textContent = label; captionEl.hidden = false; }
        else { captionEl.hidden = true; }
      }
      if (emptyEl) emptyEl.hidden = true;
      preview.classList.remove('is-empty');
    } else {
      if (imgEl) { imgEl.hidden = true; imgEl.src = ''; }
      if (captionEl) captionEl.hidden = true;
      if (emptyEl) { emptyEl.textContent = label ? label + ' (no preview image uploaded)' : 'Select an option to preview'; emptyEl.hidden = false; }
      preview.classList.add('is-empty');
    }
  }

  function bindSeatTypes(){
    $$('[data-oxf-seat-type]').forEach(function(btn){
      btn.addEventListener('click', function(){
        $$('[data-oxf-seat-type]').forEach(function(b){ b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        applySeatType(btn);
        renderSummary();
      });
    });
    // Sub-variant pill toggle (e.g. With/Without Massage under Premium First Class)
    $$('[data-oxf-seat-sub]').forEach(function(pill){
      pill.addEventListener('click', function(){
        $$('[data-oxf-seat-sub]').forEach(function(p){ p.classList.remove('is-on'); });
        pill.classList.add('is-on');
        var which = pill.getAttribute('data-oxf-seat-sub'); // 'a' or 'b'
        if (!state.seatType || !state.seatType.hasSub) return;
        state.seatType.subKey = which;
        state.seatType.subLabel = which === 'b' ? state.seatType.subBLabel : state.seatType.subALabel;
        state.seatType.subPrice = which === 'b' ? state.seatType.subBPrice : state.seatType.subAPrice;
        renderSummary();
      });
    });
  }

  // Populate + show the sub-variant toggle for the picked seat type, or hide it.
  function applySeatType(btn){
    var hasSub = btn.getAttribute('data-has-sub') === '1';
    var subAL = btn.getAttribute('data-sub-a-label') || 'Without Massage';
    var subBL = btn.getAttribute('data-sub-b-label') || 'With Massage Function';
    var subAP = num(btn.getAttribute('data-sub-a-price'));
    var subBP = num(btn.getAttribute('data-sub-b-price'));
    state.seatType = {
      key: btn.getAttribute('data-key'),
      label: btn.getAttribute('data-label'),
      price: num(btn.getAttribute('data-price')),
      hasSub: hasSub,
      subALabel: subAL, subAPrice: subAP,
      subBLabel: subBL, subBPrice: subBP,
      subKey: hasSub ? 'a' : null,
      subLabel: hasSub ? subAL : null,
      subPrice: hasSub ? subAP : 0
    };

    var wrap = $('#oxf-seat-sub');
    if (wrap) {
      wrap.hidden = !hasSub;
      if (hasSub) {
        var pillA = ROOT.querySelector('[data-oxf-seat-sub="a"]');
        var pillB = ROOT.querySelector('[data-oxf-seat-sub="b"]');
        if (pillA) {
          pillA.textContent = subAP > 0 ? subAL + ' · +$' + subAP.toLocaleString() : subAL + (subAP === 0 ? '' : '');
          pillA.classList.add('is-on');
        }
        if (pillB) {
          pillB.textContent = subBP > 0 ? subBL + ' · +$' + subBP.toLocaleString() : subBL;
          pillB.classList.remove('is-on');
        }
      }
    }
    filterSeatColorsByType(state.seatType.key);
  }

  // Hide/show seat color swatches based on the selected seat type's scope.
  // If the currently-selected color is no longer visible, auto-select the first visible one.
  function filterSeatColorsByType(typeKey){
    var swatches = $$('[data-oxf-swatch][data-cat="Seat Color"]');
    var firstVisible = null;
    swatches.forEach(function(sw){
      var scope = sw.getAttribute('data-seat-scope') || 'all';
      var visible = (scope === 'all') || (scope === typeKey) ||
                    (scope === 'manual_electric' && (typeKey === 'manual' || typeKey === 'electric'));
      sw.style.display = visible ? '' : 'none';
      if (visible && !firstVisible) firstVisible = sw;
    });
    // If the current selection is now hidden, pick the first visible one
    var currentSelected = ROOT.querySelector('[data-oxf-swatch][data-cat="Seat Color"].is-on');
    if (!currentSelected || currentSelected.style.display === 'none') {
      swatches.forEach(function(s){ s.classList.remove('is-on'); });
      if (firstVisible) {
        firstVisible.classList.add('is-on');
        var input = firstVisible.querySelector('input'); if (input) input.checked = true;
        captureSwatch(firstVisible);
      } else {
        state.seatColor = null;
      }
    }
  }

  function bindBibs(){
    $$('[data-oxf-bibs]').forEach(function(btn){
      btn.addEventListener('click', function(){
        $$('[data-oxf-bibs]').forEach(function(b){ b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        if (btn.getAttribute('data-oxf-bibs') === 'yes') {
          state.bibs = {
            label: btn.getAttribute('data-label') || 'Yes',
            price: num(btn.getAttribute('data-price')),
            variantId: btn.getAttribute('data-variant')
          };
        } else {
          state.bibs = null;
        }
        renderSummary();
      });
    });
  }

  function bindWhiteGlove(){
    var sel = $('#oxf-wg-select');
    if (!sel) return;
    sel.addEventListener('change', function(){
      captureWgSelect(sel);
      renderSummary();
    });
  }

  // Exterior color dropdown (block-based) — adds a cart line for the chosen color
  // and optionally swaps the hero image + adds a price delta.
  function bindHeroVariant(){
    var sel = $('#oxf-hero-variant-select');
    if (!sel) return;
    sel.addEventListener('change', function(){
      captureExteriorSelect(sel);
      renderSummary();
    });
  }

  // Remember the original hero image so we can fall back when a tier has no image.
  var _originalHero = { src: '', alt: '' };
  function cacheOriginalHero(){
    var heroImg = ROOT.querySelector('.oxf-hero-img img');
    if (heroImg && !_originalHero.src) {
      _originalHero.src = heroImg.src;
      _originalHero.alt = heroImg.alt || '';
    }
  }

  function captureExteriorSelect(sel){
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var isCustom = opt.getAttribute('data-is-custom') === '1';
    // Preserve any existing note when re-selecting the same custom option;
    // clear it when switching away from custom.
    var priorNote = (state.exterior && state.exterior.isCustom) ? (state.exterior.customNote || '') : '';
    state.exterior = {
      label: opt.getAttribute('data-label') || opt.text.trim(),
      price: num(opt.getAttribute('data-price')),
      variantId: opt.value || null,
      isCustom: isCustom,
      customNote: isCustom ? priorNote : ''
    };
    // Show/hide the custom color text input
    var customWrap = $('#oxf-hero-custom-color');
    var customInput = $('#oxf-hero-custom-input');
    if (customWrap) customWrap.hidden = !isCustom;
    if (customInput) {
      if (isCustom) {
        customInput.value = priorNote;
        customInput.classList.remove('is-error');
      } else {
        customInput.value = '';
        customInput.classList.remove('is-error');
      }
    }

    // Swap hero image: use the tier's image if provided, else fall back to the
    // original section-level hero image so switching between tiers always resolves.
    cacheOriginalHero();
    var img = opt.getAttribute('data-image');
    var heroImg = ROOT.querySelector('.oxf-hero-img img');
    var heroWrap = ROOT.querySelector('.oxf-hero-img');
    var targetSrc = img || _originalHero.src;
    var targetAlt = state.exterior.label || _originalHero.alt;
    if (targetSrc) {
      if (heroImg) {
        heroImg.src = targetSrc;
        heroImg.alt = targetAlt;
      } else if (heroWrap) {
        heroWrap.innerHTML = '<img src="' + esc(targetSrc) + '" alt="' + esc(targetAlt) + '" loading="lazy">';
      }
    }
  }

  function bindCustomColorInput(){
    var input = $('#oxf-hero-custom-input');
    if (!input) return;
    input.addEventListener('input', function(){
      if (state.exterior && state.exterior.isCustom) {
        state.exterior.customNote = input.value.trim();
        if (state.exterior.customNote) input.classList.remove('is-error');
        renderSummary();
      }
    });
  }

  function bindSeatCustomInput(){
    var input = document.getElementById('oxf-seat-custom-input');
    if (!input) return;
    input.addEventListener('input', function(){
      if (state.seatColor && state.seatColor.isCustom) {
        state.seatColor.note = input.value.trim();
        if (state.seatColor.note) input.classList.remove('is-error');
        renderSummary();
      }
    });
  }

  function captureWgSelect(sel){
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    state.wg = {
      tierKey: opt.value,
      label: opt.getAttribute('data-label'),
      price: num(opt.getAttribute('data-price')),
      variantId: opt.getAttribute('data-variant') || null
    };
  }

  function bindAddons(){
    $$('[data-oxf-addon]').forEach(function(row){
      var input = row.querySelector('input[type="checkbox"]');
      if (!input) return;
      row.addEventListener('click', function(e){
        if (e.target.tagName === 'INPUT') return;
        e.preventDefault();
        input.checked = !input.checked;
        toggleAddon(row, input);
      });
      input.addEventListener('change', function(){ toggleAddon(row, input); });
    });
  }
  function toggleAddon(row, input){
    row.classList.toggle('is-on', input.checked);
    var key = row.getAttribute('data-key');
    if (input.checked) {
      state.addons[key] = {
        label: row.getAttribute('data-label'),
        price: num(row.getAttribute('data-price')),
        variantId: row.getAttribute('data-variant')
      };
    } else {
      delete state.addons[key];
    }
    renderSummary();
  }

  function bindIncluded(){
    // Non-interactive rows — always in state
    $$('[data-oxf-included]').forEach(function(row){
      var key = row.getAttribute('data-key');
      state.included[key] = {
        label: row.getAttribute('data-label'),
        variantId: row.getAttribute('data-variant') || null
      };
    });
    // Reading Light chip toggle (special: switch chip → different variant)
    $$('[data-oxf-reading]').forEach(function(btn){
      btn.addEventListener('click', function(){
        $$('[data-oxf-reading]').forEach(function(b){ b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        state.reading = {
          chipLabel: btn.getAttribute('data-oxf-reading'),
          variantId: btn.getAttribute('data-variant') || null
        };
        renderSummary();
      });
    });
  }

  // ---------- Initialize state from default DOM selections ----------
  function initFromDom(){
    // Exterior color — read the initially-selected option from the hero dropdown
    captureExteriorSelect($('#oxf-hero-variant-select'));
    // Flooring — first is-on swatch
    var floor = $('[data-oxf-swatch][data-cat="Flooring"].is-on');
    if (floor) captureSwatch(floor);
    // Interior
    var interior = $('[data-oxf-swatch][data-cat="Interior Color"].is-on');
    if (interior) captureSwatch(interior);
    // Seat Type
    var seatT = $('[data-oxf-seat-type].is-on');
    if (seatT) applySeatType(seatT);
    // Apply initial seat-type filter so hidden colors don't show up on load
    if (state.seatType) filterSeatColorsByType(state.seatType.key);
    // Seat Color — capture whatever ended up visible + selected after filter
    var seatC = $('[data-oxf-swatch][data-cat="Seat Color"].is-on');
    if (seatC && seatC.style.display !== 'none') captureSwatch(seatC);
    // White Glove default — read from the dropdown's initially-selected option
    captureWgSelect($('#oxf-wg-select'));
    // Included rows
    $$('[data-oxf-included]').forEach(function(row){
      state.included[row.getAttribute('data-key')] = {
        label: row.getAttribute('data-label'),
        variantId: row.getAttribute('data-variant') || null
      };
    });
    // Reading Light default chip (first is-on chip)
    var chip = $('[data-oxf-reading].is-on');
    if (chip) {
      state.reading = {
        chipLabel: chip.getAttribute('data-oxf-reading'),
        variantId: chip.getAttribute('data-variant') || null
      };
    }
    // BIBS default = No
    state.bibs = null;
  }

  // ---------- Summary rendering ----------
  function renderSummary(){
    var box = $('#oxf-summary-rows');
    var totalEl = $('#oxf-total-value');
    if (!box || !totalEl) return;

    var rows = [];
    var total = num(CONFIG.basePrice) || 399.99;
    var baseLabel = CONFIG.baseModelLabel || 'Oxify Forge — 2.0 ATA Sitting Type';

    rows.push(row('Base Model', baseLabel, money(total)));

    if (state.exterior) {
      var extPrice = state.exterior.price || 0;
      var extLabel = state.exterior.label;
      if (state.exterior.isCustom && state.exterior.customNote) {
        extLabel += ' — ' + state.exterior.customNote;
      } else if (state.exterior.isCustom) {
        extLabel += ' — (enter details below)';
      }
      rows.push(row('Exterior Color', extLabel, extPrice > 0 ? plus(extPrice) : 'Incl.'));
      total += extPrice;
    }

    if (state.floor) rows.push(row('Flooring', state.floor.label, state.floor.price > 0 ? plus(state.floor.price) : 'Incl.'));
    if (state.interior) rows.push(row('Interior Color', state.interior.label, state.interior.price > 0 ? plus(state.interior.price) : 'Incl.'));

    if (state.seatType) {
      var sColor = state.seatColor ? ' — ' + state.seatColor.label : '';
      if (state.seatColor && state.seatColor.isCustom && state.seatColor.note) sColor += ': ' + state.seatColor.note;
      var seatLabel = state.seatType.label;
      if (state.seatType.hasSub && state.seatType.subLabel) seatLabel += ' (' + state.seatType.subLabel + ')';
      // When the sub-toggle is active, the sub-option price is the FULL seating
      // price (it replaces the base tile price). Otherwise use the tile's base price.
      var seatFullPrice = state.seatType.hasSub
        ? (state.seatType.subPrice || 0)
        : (state.seatType.price || 0);
      rows.push(row('Seating', seatLabel + sColor, seatFullPrice > 0 ? plus(seatFullPrice) : 'Incl.'));
      total += seatFullPrice;
    }

    if (state.bibs) {
      rows.push(row(CONFIG.bibsCat || 'BIBS System', state.bibs.label, state.bibs.price > 0 ? plus(state.bibs.price) : 'Incl.'));
      total += state.bibs.price;
    }

    if (state.wg && state.wg.label) {
      var wgPrice = state.wg.price || 0;
      var wgLabel = wgPrice > 0 ? plus(wgPrice) : 'Incl.';
      rows.push(row('Delivery', state.wg.label, wgLabel));
      total += wgPrice;
    }

    Object.keys(state.addons).forEach(function(k){
      var a = state.addons[k];
      rows.push(row('Add-on', a.label, plus(a.price)));
      total += a.price;
    });

    // Always-included rows
    var includedNames = [];
    Object.keys(state.included).forEach(function(k){
      if (k === 'reading' && state.reading) {
        includedNames.push(state.included[k].label + ' (' + state.reading.chipLabel + ')');
      } else {
        includedNames.push(state.included[k].label);
      }
    });
    if (includedNames.length) rows.push(row('Included', includedNames.join(' · '), 'Incl.'));

    box.innerHTML = rows.join('');
    totalEl.textContent = money(total);
  }

  function row(cat, sel, price){
    return '<div class="oxf-summary-row">' +
             '<div class="oxf-summary-info">' +
               '<div class="oxf-summary-cat">' + esc(cat) + '</div>' +
               '<div class="oxf-summary-sel">' + esc(sel) + '</div>' +
             '</div>' +
             '<div class="oxf-summary-price">' + esc(price) + '</div>' +
           '</div>';
  }

  // ---------- Save & Return ----------
  // Collect every missing selection up-front (mirrors HE5000's validateStep pattern)
  // so the customer sees one consolidated list instead of one alert per field.
  // Also highlights each missing step and scrolls to the first one.
  function validateAll(){
    var missing = [];
    // Clear prior error highlights
    $$('.oxf-card').forEach(function(c){ c.classList.remove('oxf-card-error'); });
    var customInput = $('#oxf-hero-custom-input');
    if (customInput) customInput.classList.remove('is-error');
    var seatCustomInput = $('#oxf-seat-custom-input');
    if (seatCustomInput) seatCustomInput.classList.remove('is-error');
    var heroWrap = ROOT.querySelector('.oxf-hero-variant');
    if (heroWrap) heroWrap.classList.remove('oxf-card-error');

    function flagStep(stepNum, msg){
      var card = ROOT.querySelector('.oxf-card[data-step="' + stepNum + '"]');
      if (card) card.classList.add('oxf-card-error');
      missing.push(msg);
    }

    if (state.exterior && state.exterior.isCustom && !state.exterior.customNote) {
      if (customInput) customInput.classList.add('is-error');
      if (heroWrap) heroWrap.classList.add('oxf-card-error');
      missing.push('Exterior Color: please describe your custom color (name, RAL/Pantone, or description).');
    }
    if (!state.floor) flagStep(1, 'Flooring: please select a flooring option.');
    if (!state.interior) flagStep(2, 'Interior Color: please select an interior color.');
    if (!state.seatType) flagStep(3, 'Seating: please select a seat type.');
    else if (!state.seatColor) flagStep(3, 'Seating: please select a seat color.');
    else if (state.seatColor.isCustom && !state.seatColor.note) {
      if (seatCustomInput) seatCustomInput.classList.add('is-error');
      flagStep(3, 'Seating: please describe your desired seat color.');
    }
    // BIBS System step is optional — a default "No" pill is always selected, so no check needed.
    // White Glove tier is the delivery selection under step 5
    if (ROOT.querySelector('#oxf-wg-select') && !state.wg) {
      flagStep(5, 'Delivery: please select a White Glove tier.');
    }

    return missing;
  }

  function save(){
    var missing = validateAll();
    if (missing.length) {
      alert('Please complete the following before saving:\n\n• ' + missing.join('\n• '));
      // Scroll to the first flagged step (or the hero if the custom color note is missing)
      var firstError = ROOT.querySelector('.oxf-hero-variant.oxf-card-error, .oxf-card.oxf-card-error');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var btn = $('#oxf-save-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Saving...'; }

    var payload = {
      total: computeTotal(),
      basePrice: num(CONFIG.basePrice),
      rows: buildProductRows()
    };
    var configParam = encodeURIComponent(JSON.stringify(payload));
    var ret = CONFIG.productUrl || '/products/oxify-forge';
    var variantParam = CONFIG.baseVariant ? '&variant=' + CONFIG.baseVariant : '';
    var sep = ret.indexOf('?') > -1 ? '&' : '?';
    window.location.href = ret + sep + 'oxf_config=' + configParam + variantParam;
  }

  function computeTotal(){
    var total = num(CONFIG.basePrice) || 399.99;
    if (state.exterior) total += state.exterior.price || 0;
    if (state.seatType) {
      total += state.seatType.hasSub
        ? (state.seatType.subPrice || 0)
        : (state.seatType.price || 0);
    }
    if (state.bibs) total += state.bibs.price || 0;
    if (state.wg) total += state.wg.price || 0;
    Object.keys(state.addons).forEach(function(k){ total += state.addons[k].price || 0; });
    return total;
  }

  function buildProductRows(){
    var rows = [];
    if (state.exterior) {
      var extSel = state.exterior.label;
      if (state.exterior.isCustom && state.exterior.customNote) extSel += ' — ' + state.exterior.customNote;
      rows.push({
        cat: 'Exterior Color',
        sel: extSel,
        price: state.exterior.price || 0,
        variantId: state.exterior.variantId,
        customNote: state.exterior.isCustom ? (state.exterior.customNote || '') : ''
      });
    }
    if (state.floor) rows.push({ cat: 'Flooring', sel: state.floor.label, price: state.floor.price || 0, variantId: state.floor.variantId });
    if (state.interior) rows.push({ cat: 'Interior Color', sel: state.interior.label, price: state.interior.price || 0, variantId: state.interior.variantId });
    if (state.seatType) {
      // Pick the variant that matches the current seat type + sub-variant.
      // For Premium First Class with the massage toggle on option B, we lookup
      // the `first_massage` variant instead of `first`.
      var lookupKey = state.seatType.key;
      if (state.seatType.hasSub && state.seatType.subKey === 'b' && state.seatType.key === 'first') {
        lookupKey = 'first_massage';
      }
      var seatVid = null;
      if (state.seatColor && state.seatColor.variants) seatVid = state.seatColor.variants[lookupKey];
      var seatSel = state.seatType.label;
      if (state.seatType.hasSub && state.seatType.subLabel) seatSel += ' (' + state.seatType.subLabel + ')';
      if (state.seatColor) seatSel += ' - ' + state.seatColor.label;
      var seatCustomNote = (state.seatColor && state.seatColor.isCustom) ? (state.seatColor.note || '') : '';
      if (seatCustomNote) seatSel += ' (' + seatCustomNote + ')';
      rows.push({
        cat: 'Seating',
        sel: seatSel,
        price: state.seatType.hasSub
          ? (state.seatType.subPrice || 0)
          : (state.seatType.price || 0),
        variantId: seatVid,
        seatKey: lookupKey,
        seatColor: state.seatColor ? state.seatColor.label : '',
        seatColorNote: seatCustomNote
      });
    }
    if (state.bibs) rows.push({ cat: CONFIG.bibsCat || 'BIBS System', sel: state.bibs.label, price: state.bibs.price, variantId: state.bibs.variantId });
    // Always include the selected White Glove tier so it shows in the summary panels.
    // The cart builder in oxify-forge-product-config.liquid filters by variantId, so tiers
    // without a variant ID (e.g. Curbside — no product created) show in the summary
    // but do NOT add a cart line item. Add a variant ID to the block to include it in cart.
    if (state.wg && state.wg.label) rows.push({ cat: 'White Glove Delivery', sel: state.wg.label, price: state.wg.price || 0, variantId: state.wg.variantId || null, wgTier: state.wg.tierKey });
    Object.keys(state.addons).forEach(function(k){
      var a = state.addons[k];
      rows.push({ cat: 'Add-on', sel: a.label, price: a.price, variantId: a.variantId, addonKey: k });
    });
    Object.keys(state.included).forEach(function(k){
      var inc = state.included[k];
      var vid = inc.variantId;
      var sel = inc.label;
      if (k === 'reading' && state.reading) {
        vid = state.reading.variantId;
        sel = inc.label + ' - ' + state.reading.chipLabel;
      }
      if (vid) rows.push({ cat: 'Included', sel: sel, price: 0, variantId: vid, includedKey: k });
    });
    return rows;
  }

  // ---------- Init ----------
  function init(){
    ROOT = document.getElementById('oxf-config-' + CONFIG.sectionId);
    if (!ROOT) return;
    bindSwatches();
    bindSeatTypes();
    bindBibs();
    bindWhiteGlove();
    bindHeroVariant();
    bindCustomColorInput();
    bindSeatCustomInput();
    bindAddons();
    bindIncluded();
    initFromDom();
    renderSummary();
    var saveBtn = $('#oxf-save-btn');
    if (saveBtn) saveBtn.addEventListener('click', save);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
